export const createChatMessage =
  /* GraphQL */
  `
    mutation MyMutation(
      $body: String!
      $guestId: String!
      $hotelId: String!
      $threadId: String!
      $reservationId: String
    ) {
      createChatMessage(
        input: {
          body: $body
          guestId: $guestId
          hotelId: $hotelId
          threadId: $threadId
          reservationId: $reservationId
        }
      ) {
        status
        message
      }
    }
  `;
